import './rxjs-extensions';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CheckboxComponent } from './checkbox.component';
import { CheckboxRoutingModule } from './checkbox.routing.module';

import { GenericdatasetService } from '../../services/genericdataset/genericdataset.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CheckboxRoutingModule,
    ReactiveFormsModule
  ],
  exports: [
    CheckboxComponent
  ],
  declarations: [
    CheckboxComponent
  ],
  providers: [
    GenericdatasetService
  ],
})
export class CheckboxModule { }
